/**
 * LA OFERTA — carril de BAÑO DE LUJO (high-end).
 * El rango del estimador es ALL-IN (diseño + obra + allowance de acabados curados),
 * NO construcción-sola. Debajo del mínimo = graceful disqualify (ver gate en Estimator).
 */
export const OFFER = {
  vertical: "bathroom",
  headlineEN: "Design-led master baths",
  headlineES: "Baños principales de autor",
  serviceArea: ["Pinellas", "Hillsborough", "Pasco"],

  /** 🔴 Piso de calificación (all-in, USD). Debajo de esto NO se habilita el calendario. */
  minQualifyUsd: 25000,

  /** Tiers de lujo (all-in) — la conversación, no un documento. */
  investmentTiers: [
    { id: "signature", labelEN: "Signature Refresh", range: "$25–40K", min: 25000, max: 40000 },
    { id: "spa", labelEN: "Spa / Primary Suite", range: "$40–70K", min: 40000, max: 70000 },
    { id: "estate", labelEN: "Estate Bath", range: "$70K+", min: 70000, max: Number.POSITIVE_INFINITY },
  ],
} as const;

/** Piso de calificación, para importar sin cargar todo OFFER. */
export const MIN_QUALIFY_USD = OFFER.minQualifyUsd;

export type InvestmentTierId = (typeof OFFER.investmentTiers)[number]["id"];
